import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ImageTransformation } from "../transformation/ImageTransformation.js";
import { CloudinaryTransformable } from "./CloudinaryTransformable.js";
/**
 * @desc Cloudinary image asset, with image-related transformations
 * @summary SDK
 * @memberOf SDK
 */

var CloudinaryImage = /*#__PURE__*/function (_CloudinaryTransforma) {
  _inherits(CloudinaryImage, _CloudinaryTransforma);

  var _super = _createSuper(CloudinaryImage);

  function CloudinaryImage(publicID, cloudConfig, urlConfig) {
    _classCallCheck(this, CloudinaryImage);

    /* istanbul ignore next */
    return _super.call(this, publicID, cloudConfig, urlConfig, new ImageTransformation());
  }

  return _createClass(CloudinaryImage);
}(CloudinaryTransformable);

export { CloudinaryImage };